import * as locale from './locale'
import * as constant from './constant'
import * as table from './table'
import * as api from './api'
import * as report from './report'

export default {
    locale,
    table,
    api,
    report,
    ...constant
}
